import {Component, EventEmitter, Input, Output} from '@angular/core';

import {EnergyLevelQuestionType} from 'shared/models/questions/energy-level-question-type';
import {KeyPoint} from 'shared/models/questions/keypoint';
import {TranslatedText} from 'shared/models/translated-text';

@Component({
  selector: 'type-energylevel',
  templateUrl: './type-energylevel.component.html',
  styleUrls: ['./type-energylevel.component.css'],
})
export class TypeEnergylevelComponent {

  @Input() public language: string;
  @Input() public data: EnergyLevelQuestionType;
  @Input() public inChains: Array<string>;
  @Input() public isSystemQuestion: boolean;
  @Input() public isChainSystemEditable: boolean = false;
  @Output() public dataChange: EventEmitter<EnergyLevelQuestionType>;

  public oldKeyPointCount: number = null;

  constructor() {
    this.data = new EnergyLevelQuestionType();
    this.dataChange = new EventEmitter<EnergyLevelQuestionType>();
  }

  public addKeyPoint(): void {
    if (this.oldKeyPointCount === null) {
      this.oldKeyPointCount = this.data.keyPoints.length;
    }
    this.data.addKeyPoint();
    this.dataChange.emit(this.data);
  }

  public deleteKeyPoint(index: number): void {
    this.data.deleteKeyPoint(index);
    this.dataChange.emit(this.data);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/questions/questions-details/type-components/type-energylevel/type-energylevel.component.ts